// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OAAWf{display:-ms-flexbox;display:flex;cursor:pointer;color:#0373f9;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;text-transform:uppercase;font-size:14px;font-size:.875rem;font-weight:500;line-height:17.5px;line-height:1.09375rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:1023px){.OAAWf{-ms-flex-pack:start;justify-content:flex-start;margin-top:.5rem}}._3Rs-8{margin-left:.5663rem;width:24px;width:1.5rem;height:24px;height:1.5rem}._3Rs-8 path[fill]{fill:#0373f9}", ""]);
// Exports
exports.locals = {
	"root": "OAAWf",
	"icon": "_3Rs-8"
};
module.exports = exports;
